import './Footer.css'
import React from 'react';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import { Typography } from '@mui/material';
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import TwitterIcon from '@mui/icons-material/Twitter';
import GoogleIcon from '@mui/icons-material/Google';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import HomeIcon from '@mui/icons-material/Home';
import MailIcon from '@mui/icons-material/Mail';
import PhoneIcon from '@mui/icons-material/Phone';
import DiamondIcon from '@mui/icons-material/Diamond';

export default function Footer() {
  return (
    <div class="footer">
        <br/>
        <Container maxWidth="xl">
          <Grid container>
            <Grid xs={12} sm={6} md={3}>
              <div class="footer-info">
              <Typography style={{fontWeight: 'bold', margin: '0.5vw'}}>კონტაქტი</Typography>
              </div>
              <div class="footer-info">
              <HomeIcon/>
              <Typography style={{margin: '0.5vw'}}>6000,ბათუმი,საქართველო</Typography>
              </div>
              <div class="footer-info">
              <MailIcon/>
              <a href='mailto:gisolutions@example.com' style={{margin: '0.5vw'}}><Typography >geminiimpulsesolutions@gmail.com</Typography></a>
              </div>
              <div class="footer-info">
              <PhoneIcon/>
              <Typography style={{margin: '0.5vw'}}>+ 995 555 48 11 19</Typography>
              </div><br/>
            </Grid>
            <Grid xs={12} sm={6} md={3}>
              <div class="footer-info">
              <Typography style={{fontWeight: 'bold', margin: '0.5vw'}}>ტექნოლოგიები</Typography>
              </div>            
              <div class="footer-info">
              <a href='https://www.drupal.org/' target="_blank" style={{margin: '0.5vw'}}><Typography >Drupal</Typography></a>
              </div>
              <div class="footer-info">
              <a href='https://reactjs.org/' target="_blank" style={{margin: '0.5vw'}}><Typography >React</Typography></a>
              </div>
              <div class="footer-info">
              <a href='https://flutter.dev/' target="_blank" style={{margin: '0.5vw'}}><Typography >Flutter</Typography></a>
              </div>
              <div class="footer-info">
              <a href='https://reactnative.dev/' target="_blank" style={{margin: '0.5vw'}}><Typography >React Native</Typography></a>
              </div>
              <div class="footer-info">
              <a href='https://nodejs.org/en/' target="_blank" style={{margin: '0.5vw'}}><Typography >NodeJs</Typography></a>
              </div>
              <div class="footer-info">
              <a href='https://wordpress.com/' target="_blank" style={{margin: '0.5vw'}}><Typography >Wordpress</Typography></a>
              </div><br/>
            </Grid>
            <Grid xs={12} sm={6} md={3}>
              <div class="footer-info">
              <Typography style={{fontWeight: 'bold', margin: '0.5vw'}}>ჩვენ შესახებ</Typography>
              </div>            
              <div class="footer-info">
              <a href='#stack' style={{margin: '0.5vw'}}><Typography >ტექნოლოგიები</Typography></a>
              </div>
              <div class="footer-info">
              <a href='#team' style={{margin: '0.5vw'}}><Typography >გუნდი</Typography></a>
              </div>
              <div class="footer-info">
              <a href='#contacts' style={{margin: '0.5vw'}}><Typography >კონტაქტი</Typography></a>
              </div><br/>
            </Grid>
            <Grid xs={12} sm={6} md={3}>
              <div class="footer-info">
              <DiamondIcon/>
              <Typography style={{fontWeight: 'bold', margin: '0.5vw'}}>GEMINI IMPULSE SOLUTIONS</Typography>
              </div>            
              <div class="footer-info">
              <Typography style={{margin: '0.5vw'}}>უსწრაფესი გზა მიზნის მისაღწევად.</Typography>
              </div><br/>              
              <div class="link-text">
            <Typography textAlign="left" style={{fontWeight: 'bold'}}>დაგვიკავშირდით სოციალურ ქსელებში</Typography>
            </div> 
            <div class="links">
            <a href=''>
            <FacebookOutlinedIcon/>
            </a>
            <a href=''>
            <TwitterIcon/>
            </a>
            <a href=''>
            <GoogleIcon/>
            </a>
            <a href=''>
            <InstagramIcon/>
            </a>
            <a href=''>
            <LinkedInIcon/>
            </a>
            <a href=''>
            <GitHubIcon/>
            </a>
            </div>
            </Grid>
          </Grid>
        </Container>
          <div class='footer_copy'>
              <a href=''><Typography style={{fontWeight: 'bold'}}>&copy; GIS 2022</Typography></a>
          </div>    
    </div>
  );
}
